/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace component-selector component-class-suffix */

import {
  Component,
  OnInit,
  OnDestroy,
  AfterViewInit
}                                from '@angular/core';

import { Subscription          } from 'rxjs';

import { AuthenticationService } from '../../services/authentication.service';
import { AlertService }          from '../../services/alert.service';

import { Logger                } from '../../util/logger';
import { User                  } from '../../models/user';

import {
  Router
}                                from '@angular/router';

@Component({
  selector:    '.online-details',
  template: `
    <div id="onlinedetailsdropfill" style="height: 30px; overflow: hidden; margin-left: 4px;">

      <span class="dropmenu-title" [innerHTML]="statusTitle"></span>
      <div class="dropmenu-up-content" style="padding: 0;">
       <h2>Details.</h2>
      </div>
    </div>
  `
})

/**
 *
 * @class OnlineDropupMenu
 *
 * @brief drop up menu (bottom margin) we can click for System/Docker status.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2020
 *
 */
export class OnlineDropupMenu implements OnInit, OnDestroy, AfterViewInit {


  public static icons: string[] = [
    '<i class="fas fa-circle online-status-icon-red"></i>',
    '<i class="fas fa-circle online-status-icon-yellow"></i>',
    '<i class="fas fa-circle online-status-icon-green"></i>',
  ];

  /** the count down to expiry */
  public statusTitle: string = 'Unknown';

  public staticIcon: string = '';

  /** id for our count down timer */
  private countDownTimer: number = 0;

  constructor(
    private auth:   AuthenticationService,
    private alerts: AlertService,
    private router: Router
  ) {

    Logger.debug('[UserDropDown]', 'constructing...');

  }

  ngAfterViewInit(): void {


  }

  /** @brief set up the dockable views and view manager */
  ngOnInit(): void {

    this.statusTitle = OnlineDropupMenu.icons[2] + '&nbsp;Online';
  }

  ngOnDestroy() {


  }


}
